<script>
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {
  required,
  email,
  helpers,
  minLength,
  maxLength,
  minValue,
} from "vuelidate/lib/validators";
import { Order } from "@/services/westore/entities";
import User from "@/services/westore/entities/user";
import Customer from "@/services/westore/entities/customer";
import ProductVariant from "@/services/westore/entities/product-variant";
import Vue from "vue";
import Faqs from "../../../components/faqs.vue";
import myMixin from "../../../plugins/myMixin";
import FormSkeleton from "../../../components/skeletons/form-skeleton.vue";
import { mapGetters } from "vuex";
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
const alpha = helpers.regex("alpha", /^[a-zA-Z_ ]*$/);
export default {
  mixins: [myMixin],
  page: {
    title: "Create Order",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Faqs,
    FormSkeleton,
    VueTelInput,
  },
  data() {
    return {
      title: this.$t("Add New Order"),
      subtitle: "Please fill all the mandatory fields.",
      submitted: false,
      loader: false,
      showContentLoader: true,
      isSuccess: false,
      successMessage: "",
      faqs: [
        { question: "Question 1", answer: "Answer Answer" },
        {
          question: "How long would it take for the order to be executed?",
          answer:
            "To enable automatic updates for Admin Columns Pro, enter your license key. If you don't have a license key, please see details & pricing.",
        },
      ],
      expandForm: false,
      formInputs: {
        customer_id: null,
        recipient_name: "",
        recipient_email: "",
        recipient_phone: "",
        country_id: null,
        city_id: null,
        recipient_address: "",
        payment_method: null,
        delivery_speed: null,
        so_number:"",
        invoice_number:"",
        products: [
          {
            id: null,
            sku: "",
            name: "",
            weight: "",
            price: "",
            quantity: 1,
            clicked: false,
          },
        ],
      },
      countries: [],
      cities: [],
      userData: null,
      customer_type: null,
      recipientSuggestionData: [],
      paymentTerms: [],
      deliverySpeedTypes: [],
      skuSuggestionData: [],
    };
  },
  validations: {
    formInputs: {
      recipient_name: {
        required,
        alpha,
      },
      recipient_email: {
        required,
        email,
      },
      recipient_phone: {
        required,
      },
      city_id: {
        required,
      },
      country_id: {
        required,
      },
      recipient_address: {
        required,
      },
      payment_method: {
        required,
      },
      delivery_speed: {
        required,
      },
      products: {
        required,
        $each: {
          sku: {
            required,
            minLength: minLength(3),
            maxLength: maxLength(100),
          },
          name: {
            required,
            minLength: minLength(3),
            maxLength: maxLength(100),
          },
          weight: {
            required,
            minValue: minValue(0),
          },
          price: {
            required,
            minValue: minValue(0),
          },
          quantity: {
            required,
          },
        },
      },
    },
  },
  created() {
    this.fetchUser();
    this.fetchOptions().then(() => this.init());
  },
  computed: {
    ...mapGetters({
      userCountry: ["auth/userCountry"],
      services: ["auth/services"],
    }),
    checkLoader() {
      return this.loader;
    },
  },
  watch: {
    async ["formInputs.country_id"](val) {
      const { data: cities } = await Order.getCities(val);
      this.cities = cities;
      this.formInputs.city_id = this.cities[0]?.id;
    },
  },
  methods: {
    init() {
      this.formInputs.city_id = this.cities[0].id;
      this.formInputs.payment_method = this.paymentTerms[0].value;
      if (this.customer_type == 2) {
        this.formInputs.recipient_name = this.userData.first_name;
        this.formInputs.recipient_email = this.userData.email;
        this.formInputs.recipient_phone = this.userData.phone;
        this.formInputs.recipient_address = this.address;
        this.formInputs.delivery_speed = this.deliverySpeedTypes[1].value;
      } else {
        this.formInputs.delivery_speed = this.deliverySpeedTypes[0].value;
      }
      this.showContentLoader = false;
    },
    submitForm() {
      this.submitted = true;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loader = true;
        this.logGAEvent(
          "order",
          "submit",
          "submit new order after inserting all order details"
        );
        Order.store(this.formInputs)
          .then((res) => {
            this.loader = false;
            this.$toast.success("Order has been created successfully");

            setTimeout(
              () =>
                this.$router.push({
                  name: "order-details",
                  params: { id: res.data.data.id },
                }),
              2000
            );
          })
          .catch(({ response }) => {
            this.loader = false;
            this.$toast.error(response.data.message);
            // this.$toast.error("Something went wrong,please try again");
          });
      }
    },
    async fetchOptions() {
      const { data: options } = await Order.getOptions();
      this.paymentTerms = options.payment_methods;
      this.deliverySpeedTypes = options.delivery_speed;
      const { data: countries } = await Order.getCountries();

      this.countries = countries;
      this.formInputs.country_id = this.userCountry.id;
      const { data: cities } = await Order.getCities(this.userCountry.id);
      this.cities = cities;

      return Promise.resolve();
    },

    async fetchUser() {
      await User.info().then((data) => {
        this.userData = data.data;
        this.address = data.meta.country.name;
        this.customer_type = data.data.customer_type.value;
      });
    },
    AddProductRow() {
      this.formInputs.products.push({
        id: null,
        sku: "",
        name: "",
        weight: "",
        price: "",
        quantity: 1,
      });
    },
    deleteProductRow(index) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.formInputs.products.splice(index, 1);
        }
      });
    },
    loadRecipientSuggestions() {
      this.recipientSuggestionData = [];
      if (this.formInputs.recipient_name.length < 3) {
        return;
      }
      Customer.search({ name: this.formInputs.recipient_name })
        .then((res) => {
          this.recipientSuggestionData = res.data;
        })
        .finally(() => {
          if (this.customer_type == 1) {
            this.autoFillRecipientFields(null);
          }
        });
    },
    recipientSelected(selectedIndex) {
      this.autoFillRecipientFields(selectedIndex);
    },
    autoFillRecipientFields(selectedIndex) {
      if (selectedIndex === null) {
        this.formInputs.customer_id = null;
        this.formInputs.recipient_email = "";
        this.formInputs.recipient_phone = "";
        this.formInputs.recipient_address = "";

        return;
      }
      this.formInputs.customer_id =
        this.recipientSuggestionData[selectedIndex]?.id;
      this.formInputs.recipient_name =
        this.recipientSuggestionData[selectedIndex]?.name;
      this.formInputs.recipient_email =
        this.recipientSuggestionData[selectedIndex]?.email;
      this.formInputs.recipient_phone =
        this.recipientSuggestionData[selectedIndex]?.phone;
      this.formInputs.recipient_address =
        this.recipientSuggestionData[selectedIndex]?.default_address?.details;
      this.recipientSuggestionData = [];
    },
    async loadSkuSuggestions(productIndex) {
      if (this.formInputs.products[productIndex].sku.length < 2) {
        this.skuSuggestionData = [];
        return;
      }

      await ProductVariant.search({
        sku: this.formInputs.products[productIndex].sku,
      }).then((res) => {
        Vue.set(this.skuSuggestionData, productIndex, res.data);
        this.autoFillSKUFields(productIndex, null);
      });
    },
    skuSelected(productIndex, selectedIndex) {
      this.autoFillSKUFields(productIndex, selectedIndex);
    },
    autoFillSKUFields(productIndex, selectedIndex) {
      if (selectedIndex === null) {
        this.formInputs.products[productIndex].id = null;
        this.formInputs.products[productIndex].name = "";
        this.formInputs.products[productIndex].price = "";
        this.formInputs.products[productIndex].weight = "";
        return;
      }

      Vue.set(this.formInputs.products, productIndex, {
        id: this.skuSuggestionData[productIndex][selectedIndex].id,
        sku: this.skuSuggestionData[productIndex][selectedIndex].sku,
        name: this.skuSuggestionData[productIndex][selectedIndex].name,
        price: this.skuSuggestionData[productIndex][selectedIndex].price,
        weight: this.skuSuggestionData[productIndex][selectedIndex].weight,
        quantity: 1,
        clicked: true,
      });

      this.skuSuggestionData = [];
    },
    toggleFormListener(val) {
      this.expandForm = val;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :subtitle="subtitle" />
    <div class="row">
      <div
        class="col-md-9 col-sm-12 order-2 order-sm-12"
        :class="expandForm && 'col-md-11 col-sm-12'"
      >
        <div class="card">
          <FormSkeleton v-if="showContentLoader" />
          <div class="card-body" v-else>
            <div class="row">
              <div class="col-12">
                <form class="form-horizontal" @submit.prevent="submitForm">
                  <!-- Recipient Name -->
                  <b-form-group
                    class="mb-1"
                    label-size="lg"
                    :label="
                      customer_type == 1
                        ? $t('Recipient Name *')
                        : $t('Merchant Name *')
                    "
                  >
                    <b-form-input
                      v-model="formInputs.recipient_name"
                      list="recipientSuggestionOptions"
                      @keyup="loadRecipientSuggestions"
                      type="text"
                      :class="{
                        'is-invalid':
                          submitted && $v.formInputs.recipient_name.$error,
                      }"
                    ></b-form-input>
                    <div
                      v-if="submitted && !$v.formInputs.recipient_name.alpha"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.formInputs.recipient_name.alpha"
                        >Name must be alphabet characters
                      </span>
                    </div>
                    <div
                      class="suggestions-list"
                      v-if="recipientSuggestionData.length"
                    >
                      <ul>
                        <li
                          v-for="(item, index) in recipientSuggestionData"
                          :key="index"
                          @click="recipientSelected(index)"
                        >
                          {{ item.name }}
                        </li>
                      </ul>
                    </div>
                  </b-form-group>
                  <!-- Recipient Email -->
                  <b-form-group
                    class="mb-3"
                    label-size="lg"
                    :label="
                      customer_type == 1
                        ? $t('Recipient Email *')
                        : $t('Merchant Email *')
                    "
                  >
                    <b-form-input
                      v-model="formInputs.recipient_email"
                      type="text"
                      :class="{
                        'is-invalid':
                          submitted && $v.formInputs.recipient_email.$error,
                      }"
                    ></b-form-input>
                    <div
                      v-if="submitted && !$v.formInputs.recipient_email.email"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.formInputs.recipient_email.email"
                        >Enter a valid email</span
                      >
                    </div>
                  </b-form-group>
                  <!-- Recipient Phone -->
                  <b-form-group
                    class="mb-3"
                    label-size="lg"
                    :label="
                      customer_type == 1
                        ? $t('Recipient Phone *')
                        : $t('Merchant Phone *')
                    "
                  >
                    <VueTelInput
                      v-model="formInputs.recipient_phone"
                      :defaultCountry="'AE'"
                      :preferred-countries="['AE', 'SA', 'EG', 'US']"
                      :dropdownOptions="{
                        showDialCodeInSelection: true,
                        showDialCodeInList: true,
                        showFlags: true,
                        showSearchBox: true,
                      }"
                      :inputOptions="{
                        placeholder: 'Phone',
                        maxlength: 15,
                        required: true,
                      }"
                      :invalidMsg="'invalid number'"
                      :validCharactersOnly="true"
                      :mode="'international'"
                    />
                    <span
                      :class="
                        submitted && $v.formInputs.recipient_phone.$error
                          ? 'invalid-feedback'
                          : 'text-muted'
                      "
                      >e.g "(xx) xxxx-xxxx"</span
                    >
                  </b-form-group>
                  <!-- Recipient Country -->
                  <b-form-group
                    class="mb-3"
                    label-size="lg"
                    :label="
                      customer_type == 1
                        ? $t('Recipient Country *')
                        : $t('Merchant Country *')
                    "
                  >
                    <b-form-select
                      v-model="formInputs.country_id"
                      class="form-select"
                      value-field="id"
                      text-field="name"
                      :options="countries"
                      type="text"
                      :class="{
                        'is-invalid': submitted && $v.formInputs.city_id.$error,
                      }"
                      :disabled="!services.international"
                    ></b-form-select>
                  </b-form-group>
                  <!-- Recipient City/Area -->
                  <b-form-group
                    class="mb-3"
                    label-size="lg"
                    :label="
                      customer_type == 1
                        ? $t('Recipient City/Area *')
                        : $t('Merchant City/Area *')
                    "
                  >
                    <b-form-select
                      v-model="formInputs.city_id"
                      class="form-select"
                      value-field="id"
                      text-field="name"
                      :options="cities"
                      type="text"
                      :class="{
                        'is-invalid': submitted && $v.formInputs.city_id.$error,
                      }"
                    ></b-form-select>
                  </b-form-group>
                  <!-- Recipient Delivery address -->
                  <b-form-group
                    class="mb-3"
                    label-size="lg"
                    :label="
                      customer_type == 1
                        ? $t('Recipient Delivery Address *')
                        : $t('Merchant Delivery Address *')
                    "
                  >
                    <b-form-input
                      v-model="formInputs.recipient_address"
                      type="text"
                      :class="{
                        'is-invalid':
                          submitted && $v.formInputs.recipient_address.$error,
                      }"
                    ></b-form-input>
                  </b-form-group>
                  <!-- Payment Term -->
                  <b-form-group
                    class="mb-3"
                    label-size="lg"
                    :label="
                      customer_type == 1
                        ? $t('Payment Term *')
                        : $t('Don’t Collect Payment *')
                    "
                  >
                    <b-form-select
                      v-model="formInputs.payment_method"
                      class="form-select"
                      value-field="value"
                      text-field="text"
                      :options="paymentTerms"
                      type="text"
                      :class="{
                        'is-invalid':
                          submitted && $v.formInputs.payment_method.$error,
                      }"
                    ></b-form-select>
                  </b-form-group>
                  <!-- Recipient Delivery Speed -->
                  <b-form-group
                    class="mb-3"
                    label-size="lg"
                    :label="$t('Delivery Speed *')"
                  >
                    <b-form-select
                      v-model="formInputs.delivery_speed"
                      class="form-select"
                      value-field="value"
                      text-field="text"
                      :options="deliverySpeedTypes"
                      type="text"
                      :class="{
                        'is-invalid':
                          submitted && $v.formInputs.delivery_speed.$error,
                      }"
                    ></b-form-select>
                  </b-form-group>

                  <!-- 3PL-Invoice Number -->
                  <b-form-group
                    v-if="customer_type == 2"
                    class="mb-3"
                    label-size="lg"
                    :label="$t('Invoice Number')"
                  >
                    <b-form-input
                      v-model="formInputs.invoice_number"
                      type="text"
                    ></b-form-input>
                  </b-form-group>
                  <!-- SO Number -->
                  <b-form-group
                    v-if="customer_type == 2"
                    class="mb-3"
                    label-size="lg"
                    :label="$t('SO Number')"
                  >
                    <b-form-input
                      v-model="formInputs.so_number"
                      type="text"
                    ></b-form-input>
                  </b-form-group>
                  <!-- Products -->
                  <b-form-group
                    class="mb-0 mt-5"
                    label-size="lg"
                    :label="$t('Add the items for delivery *')"
                  >
                    <div
                      v-for="(item, pIndex) in formInputs.products"
                      :key="pIndex"
                      class="row"
                    >
                      <div class="mb-0 col-xl-4 col-lg-4">
                        <label for="sku">{{ $t("SKU") }}*</label>
                        <input
                          id="sku"
                          v-model="item.sku"
                          type="text"
                          class="form-control"
                          :class="{
                            'is-invalid':
                              submitted &&
                              $v.formInputs.products.$each[pIndex].sku.$error,
                          }"
                          @keyup="loadSkuSuggestions(pIndex)"
                        />
                        <div
                          class="suggestions-list"
                          v-if="
                            skuSuggestionData.length &&
                            skuSuggestionData[pIndex] &&
                            skuSuggestionData[pIndex].length
                          "
                          style="width: 100%"
                        >
                          <ul>
                            <li
                              v-for="(skuItem, skuIndex) in skuSuggestionData[
                                pIndex
                              ]"
                              :key="skuIndex"
                              @click="skuSelected(pIndex, skuIndex)"
                            >
                              {{ skuItem.sku }} - {{ skuItem.name }}
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="mb-3 col-xl-4 col-lg-4">
                        <label for="name" class="product-label">
                          {{ $t("PRODUCT NAME") }}*
                        </label>
                        <input
                          id="name"
                          v-model="item.name"
                          type="text"
                          class="form-control"
                          :class="{
                            'is-invalid':
                              submitted &&
                              $v.formInputs.products.$each[pIndex].name.$error,
                          }"
                        />
                      </div>
                      <div class="mb-3 col-xl-4 col-lg-4">
                        <label for="name" class="product-label">
                          {{ $t("Weight (gram)") }}*
                        </label>
                        <input
                          id="name"
                          v-model="item.weight"
                          type="number"
                          min="0"
                          class="form-control"
                          :class="{
                            'is-invalid':
                              submitted &&
                              $v.formInputs.products.$each[pIndex].weight
                                .$error,
                          }"
                        />
                      </div>
                      <div class="mb-3 col-xl-4 col-lg-4">
                        <label for="price" class="product-label">
                          {{ $t("UNIT PRICE (AED)") }}*
                        </label>
                        <input
                          id="price"
                          v-model="item.price"
                          type="number"
                          step="any"
                          class="form-control"
                          :class="{
                            'is-invalid':
                              submitted &&
                              $v.formInputs.products.$each[pIndex].price.$error,
                          }"
                        />
                      </div>
                      <div class="mb-3 col-xl-4 col-lg-4">
                        <label for="quantity" class="product-label">
                          {{ $t("QUANTITY") }}*
                        </label>
                        <input
                          id="quantity"
                          v-model="item.quantity"
                          type="number"
                          min="1"
                          class="form-control"
                          :class="{
                            'is-invalid':
                              submitted &&
                              $v.formInputs.products.$each[pIndex].quantity
                                .$error,
                          }"
                        />
                      </div>
                      <div class="mb-3 col-xl-3 col-lg-3">
                        <label class="product-label">
                          {{ $t("Total") }}*
                        </label>
                        <input
                          :value="item.price * item.quantity"
                          disabled
                          class="form-control"
                        />
                      </div>
                      <div class="col-xl-1 align-self-center col-lg-4">
                        <div class="d-grid">
                          <b-btn
                            class="btn btn-danger btn-block mt-4"
                            @click="deleteProductRow(pIndex)"
                            ><i class="bx bx-trash"></i
                          ></b-btn>
                        </div>
                      </div>
                    </div>
                    <div v-if="submitted && formInputs.products.length === 0">
                      <code class="pink--text"
                        >The items for delivery is required.</code
                      >
                    </div>
                    <input
                      type="button"
                      class="btn btn-success mt-3 mt-lg-0"
                      :value="this.$t('Add SKU')"
                      @click="AddProductRow"
                    />
                  </b-form-group>
                  <!-- Submit -->
                  <div class="row float-end">
                    <div class="col-md-2">
                      <v-progress-circular
                        v-if="checkLoader"
                        :size="30"
                        color="secondary"
                        indeterminate
                      ></v-progress-circular>
                      <b-button
                        v-else
                        type="submit"
                        variant="primary"
                        class="btn-block"
                      >
                        {{ $t("Submit") }}
                      </b-button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <!-- end row -->
          </div>
        </div>
        <!-- end card -->
      </div>
      <div
        class="order-1 order-sm-12"
        :class="
          expandForm
            ? 'col-md-1 col-sm-12 d-flex justify-content-end'
            : 'col-md-3 col-sm-12'
        "
      >
        <Faqs :faqs="faqs" title="Orders" @toggleForm="toggleFormListener">
          <v-expansion-panels>
            <v-expansion-panel class="panel">
              <v-expansion-panel-header class="panel__header">
                Question 1
                <template v-slot:actions>
                  <v-icon color="pink"> $expand </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="panel__content opacity-75">
                Answer Answer
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel class="panel">
              <v-expansion-panel-header class="panel__header">
                How long would it take for the order to be executed?
                <template v-slot:actions>
                  <v-icon color="pink"> $expand </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="panel__content opacity-75">
                To enable automatic updates for Admin Columns Pro, enter your
                license key. If you don't have a license key, please see details
                & pricing.
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </Faqs>
      </div>

      <!-- end col -->
    </div>
    <v-snackbar
      color="success accent-2"
      elavation="24"
      top
      right
      v-model="isSuccess"
    >
      {{ successMessage }}
    </v-snackbar>
  </Layout>
</template>
<style lang="scss" scoped>
.suggestions-list {
  position: absolute;
  width: 50%;
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 10000;
}

.suggestions-list ul {
  width: 100%;
  background: var(--v-shadow-base);
  list-style: none;
  margin: 0;
  padding: 1px;
}

.suggestions-list ul li {
  background: var(--v-white-base);
  padding: 4px;
}

.suggestions-list ul li:hover {
  cursor: pointer;
  background: var(--v-shadow-base);
}
</style>
<style lang="scss">
.vue-tel-input {
  height: 36px !important;
  color: #495057;
  background-color: #fff !important;
  border: 1px solid #ced4da !important;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  &:focus-within {
    box-shadow: unset !important;
    border: 1px solid #b9bfc4 !important;
  }
  ul::-webkit-scrollbar {
    width: 6px !important;
  }

  ul::-webkit-scrollbar-track {
    background-color: darkgrey !important;
  }

  ul::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3) !important;
  }

  ul {
    overflow-x: hidden !important;
  }
}
.vti__search_box {
  width: 99%;
}
.vti__dropdown-list {
  padding-left: 0 !important;
  width: 56vw !important;
  max-height: 130px !important;
}
.vti__dropdown {
  border-right: 1px solid #bbb;
  &:hover {
    background: transparent !important;
  }
}

@media screen and (max-width: 768px) {
  .vti__dropdown-list {
    width: 78vw !important;
    max-height: 140px !important;
  }
}
</style>
